"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var sort_1 = require("../../sort");
var AccountsCtrl = /** @class */ (function () {
    function AccountsCtrl() {
        this.loading = mobx_1.observable.map();
    }
    Object.defineProperty(AccountsCtrl.prototype, "users", {
        get: function () {
            if (services_1.Services.Department.current == null) {
                return [];
            }
            var users = (services_1.Services.UserProfile.list || []).slice();
            sort_1.IkeSort.byKey(users, ['role', 'username'], sort_1.IkeSort.ASC);
            return users;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountsCtrl.prototype, "isDepartmentAdmin", {
        get: function () {
            for (var _i = 0, _a = this.users; _i < _a.length; _i++) {
                var account = _a[_i];
                if (account.objectId === services_1.Services.User.current.objectId && services_1.Services.UserProfile.isDepartmentAdmin(account)) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountsCtrl.prototype, "pendingUsers", {
        get: function () {
            if (!this.isDepartmentAdmin) {
                return [];
            }
            return services_1.Services.Department.Invite.list || [];
        },
        enumerable: false,
        configurable: true
    });
    AccountsCtrl.prototype.canRemove = function (role) {
        return role === core_api_1.IkeUserRole.USER;
    };
    AccountsCtrl.prototype.haveExtraRoles = function () {
        return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_EXTRA_ROLES) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
    };
    AccountsCtrl.prototype.inviteUsers = function (emails, role) {
        return services_1.Services.Department.Invite.request(emails, role);
    };
    AccountsCtrl.prototype.setLoading = function (objectId, loading) {
        if (loading) {
            this.loading.set(objectId, true);
        }
        else {
            this.loading.delete(objectId);
        }
    };
    AccountsCtrl.prototype.removeUserInvite = function (invite) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setLoading(invite.objectId, true);
                        return [4 /*yield*/, services_1.Services.Department.Invite.revoke(invite.objectId)];
                    case 1:
                        _a.sent();
                        this.setLoading(invite.objectId, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountsCtrl.prototype.removeUser = function (user) {
        return this.setRole(user, core_api_1.IkeUserRole.NONE);
    };
    AccountsCtrl.prototype.setUserRole = function (user, role) {
        return this.setRole(user, role);
    };
    AccountsCtrl.prototype.setRole = function (user, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objectId = user.objectId;
                        this.setLoading(objectId, true);
                        return [4 /*yield*/, services_1.Services.Department.setUserRole(objectId, role)];
                    case 1:
                        _a.sent();
                        this.setLoading(objectId, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountsCtrl.prototype.isLoadingUser = function (user) {
        return this.loading.has(user.objectId);
    };
    AccountsCtrl.prototype.isLoadingInvite = function (invite) {
        return this.loading.has(invite.objectId);
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], AccountsCtrl.prototype, "users", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], AccountsCtrl.prototype, "isDepartmentAdmin", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], AccountsCtrl.prototype, "pendingUsers", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountsCtrl.prototype, "setLoading", null);
    return AccountsCtrl;
}());
exports.AccountsCtrl = AccountsCtrl;
//# sourceMappingURL=accounts.ctrl.js.map